import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ModuleId } from '@soleran/module';
import { MAX_PAGE_SIZE } from '@soleran/report';
import { EMPTY, Subscription } from 'rxjs';
import { GlobalSearchService } from '../../global-search.service';
import { IRecordSearchResult } from '../../record-search-result';

@Component({
  selector: 'app-advanced-search-record-table',
  templateUrl: './advanced-search-record-table.component.html',
  styleUrls: ['../search-table.scss'],
})
export class AdvancedSearchRecordTableComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() title = 'Records';
  @Input() term!: string;
  @Input() pageSize = 8;
  @Input() moduleIds: ModuleId[] = [];
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @Output() itemClick = new EventEmitter<{
    event: MouseEvent;
    item: IRecordSearchResult;
  }>();
  readonly dateFormat: any = 'M/dd/yyyy';
  readonly columnDefs = ['result', 'module', 'date'];
  isBusy = false;
  dataSource!: MatTableDataSource<IRecordSearchResult>;
  private _searchSub = new Subscription();

  constructor(private _gs: GlobalSearchService) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<IRecordSearchResult>([]);
    this.dataSource.paginator = this.paginator;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this._isRefetchableChange(changes) || !this.dataSource) return;
    this._searchSub.unsubscribe();
    this.dataSource.data = [];
    this.isBusy = true;
    this._searchSub = this._search().subscribe({
      next: (r) => {
        this.isBusy = false;
        this.dataSource.data = [...this.dataSource.data, r];
      },
      complete: () => (this.isBusy = false),
    });
  }

  ngOnDestroy() {
    this._searchSub.unsubscribe();
  }
  private _search() {
    const isFetchable = this.term && this.pageSize && this.moduleIds?.length;
    return isFetchable
      ? this._gs.get({
          searchText: this.term,
          moduleIds: this.moduleIds,
          maxResultsPerModule: MAX_PAGE_SIZE,
          maxResults: MAX_PAGE_SIZE,
        })
      : EMPTY;
  }
  private _isRefetchableChange(changes: SimpleChanges) {
    return changes['term'] || changes['moduleIds'] || changes['pageSize'];
  }
}
